var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestartAlt = function SvgRestartAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 20.658q-2.814-.366-4.657-2.48T4.5 13.228q0-1.525.602-2.922A7.6 7.6 0 0 1 6.788 7.85l1.07 1.07a5.5 5.5 0 0 0-1.39 1.95A6 6 0 0 0 6 13.227q0 2.2 1.405 3.878T11 19.158zm2 .019v-1.5q2.166-.439 3.583-2.1Q18 15.418 18 13.228q0-2.5-1.75-4.25T12 7.227h-.354l1.35 1.35-1.054 1.054L8.79 6.477l3.153-3.154 1.054 1.054-1.35 1.35H12q3.138 0 5.32 2.18 2.18 2.18 2.18 5.32 0 2.823-1.848 4.927T13 20.677"
  })));
};
export default SvgRestartAlt;